import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class LoginGuard {
  private readonly _authService = inject(MsalService);
  private readonly _router = inject(Router);

  canActivate(): boolean {
    const accounts = this._authService.instance.getAllAccounts();
    if (accounts?.length) {
      this._authService.instance.setActiveAccount(accounts[0]);
      this._router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
